module.exports = __webpack_public_path__ + "img/organization-3.6b283009.jpg";